function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useForm } from 'react-hook-form';
import { useFetcher } from 'react-router-dom';
import { Translate } from "../../../../../I18N";

import { Button, Card, Sidepanel } from "../../../../Components/UI";
import { InputField, MultiSelect } from "../../../../Components/Forms";













const isUnique = (
name,
selectedGroup,
userGroups) =>

!(userGroups !== null && userGroups !== void 0 && userGroups.find(
  (userGroup) =>
  userGroup._id !== (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup._id) &&
  userGroup.name.trim().toLowerCase() === name.trim().toLowerCase()
));

const getFieldError = (type) => {
  switch (type) {
    case 'required':
      return 'Name is required';
    case 'validate':
      return 'Duplicated name';
    case 'maxLength':
      return 'Name is too long';
    case 'minLength':
      return 'Name is too short';
    default:
      return undefined;
  }
};

const GroupFormSidepanel = ({
  selectedGroup,
  showSidepanel,
  setShowSidepanel,
  setSelected,
  groups,
  users
}) => {var _errors$name, _selectedGroup$member;
  const fetcher = useFetcher();

  const defaultValues = { name: '', members: [] };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset
  } = useForm({
    defaultValues,
    values: selectedGroup
  });

  const closeSidepanel = () => {
    reset(defaultValues);
    setSelected(undefined);
    setShowSidepanel(false);
  };

  const formSubmit = async (data) => {
    const formData = new FormData();
    const formattedData = _objectSpread(_objectSpread({},
    data), {}, {
      members: data.members.map((member) => ({ refId: member.refId })) });


    if (data._id) {
      formData.set('intent', 'edit-group');
    } else {
      formData.set('intent', 'new-group');
    }

    formData.set('data', JSON.stringify(formattedData));
    fetcher.submit(formData, { method: 'post' });
    setShowSidepanel(false);
    reset(defaultValues);
  };

  return /*#__PURE__*/(
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: closeSidepanel,
      title: selectedGroup ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit group") : /*#__PURE__*/_jsx(Translate, {}, void 0, "New group") }, void 0, /*#__PURE__*/

    _jsx("form", { onSubmit: handleSubmit(formSubmit), className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col flex-grow gap-4" }, void 0, /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Group Options") }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "block mb-1 font-bold" }, void 0, "Name"),
      id: "name",
      autoComplete: "off",
      errorMessage: getFieldError((_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.type),
      className: "mb-1" },
    register('name', {
      required: true,
      validate: (username) => isUnique(username, selectedGroup, groups),
      maxLength: 50,
      minLength: 3
    }))
    )
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "mb-5 border rounded-md shadow-sm border-gray-50" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      label: /*#__PURE__*/
      _jsx(Translate, { className: "block w-full text-base font-semibold bg-gray-50 text-primary-700" }, void 0, "Members"

      ),

      onChange: (selected) =>
      setValue(
        'members',
        selected.map((s) => ({ refId: s })),
        { shouldDirty: true }
      ),

      options:
      (users === null || users === void 0 ? void 0 : users.map((user) => ({ label: user.username, value: user._id }))) || [],

      value: (selectedGroup === null || selectedGroup === void 0 ? void 0 : (_selectedGroup$member = selectedGroup.members) === null || _selectedGroup$member === void 0 ? void 0 : _selectedGroup$member.map((member) => member.refId)) || [],
      placeholder: "Nothing selected" }
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "button", styling: "outline", onClick: closeSidepanel }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "submit" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    )
    ));

};

export { GroupFormSidepanel };